export default __webpack_public_path__ + "static/media/user.6b2967b0.svg";